import React, { useContext } from 'react';
import { CopyContext } from '../provider/MyProvider';
import { heroBg } from '../assets';
import './HeroBanner.css';

export const HeroBanner = ({ handleForm, navClick }) => {
    const { heroPage } = useContext(CopyContext);

  return (
    <section 
        className="hero" 
        style={{
            backgroundImage: `url(${heroBg})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat"
        }}
    >
        
        <div className="hero-content">
            <h1>The influencer marketing product built for speed, scalability, and collaboration.</h1>
            <p>TrueRep tracks and manages the data you need (and nothing you don't), so you and your partners can go from initial pitch to deal close, fast.</p>
            <button 
                className="btn-lime" 
                onClick={handleForm}
                >Sign Up
            </button>
        </div>

        <video 
            autoPlay 
            muted 
            loop 
            onClick={() => navClick(heroPage.video)}>
            <source src={heroPage.video} />
        </video>

    </section>
  )
};
